module.exports = __webpack_public_path__ + "c7b4b8d810a91020978267e26ef4ecc4.png";